<template>
  <div class="single-car-comparison-component list">
    <div v-for="(shortlistItem, index) in shortlist.quotes" :key="'shortlist-list-' + index">
      <!-- Large -->
      <comparison-grid-large v-if="expanded[shortlistItem.derivativeID] === true"
        :quote="shortlistItem"
        :shortlist="shortlist"
        :session="session"
        :classes="classes"
        :list-index="index"
        :selected-quote="selectedQuote"
        :expanded="expanded[shortlistItem.derivativeID]"
        v-on:update-expanded-status="updateExpandedStatus(shortlistItem.derivativeID, $event)"
        v-on:select-quote="updateSelectedQuote($event)"
      ></comparison-grid-large>

      <!-- Small -->
      <comparison-list-small v-else
        :quote="shortlistItem"
        :shortlist="shortlist"
        :session="session"
        :classes="classes"
        :list-index="index"
        :selected-quote="selectedQuote"
        :expanded="expanded"
        v-on:update-expanded-status="updateExpandedStatus(shortlistItem.derivativeID, $event)"
        v-on:select-quote="updateSelectedQuote($event)"
      ></comparison-list-small>
    </div>
  </div>

</template>

<script>
import MpgSlider from "./mpg-slider";
import ComparisonGridLarge from "./comparison-grid-large";
import ComparisonListSmall from "./comparison-list-small";

export default {
  name: "comparison-list",
  components: {ComparisonListSmall, ComparisonGridLarge, MpgSlider},
  props: [
    "classes",
    "quote",
    "shortlist",
    "session",
    "selectedQuote"
  ],
  data() {
    return {
      expanded: [],
    }
  },
  watch: {},
  methods: {
    updateSelectedQuote(event) {
      this.$emit('select-quote', event);
    },
    updateExpandedStatus(derivativeId, value) {
      this.expanded = [];
      this.expanded[derivativeId] = value;
    },

  }
}
</script>

<style scoped>

</style>
